import React from 'react';
import Icon from '../../../components/AppIcon';

const PANIndiaCoverage = () => {
  const deliveryHubs = [
    { id: 1, city: 'Mumbai', status: 'Operational', statusColor: 'bg-green-500', region: 'Western India' },
    { id: 2, city: 'Delhi NCR', status: 'Operational', statusColor: 'bg-green-500', region: 'Northern India' },
    { id: 3, city: 'Bangalore', status: 'Prime Hub', statusColor: 'bg-blue-500', region: 'Southern India' },
    { id: 4, city: 'Chennai', status: 'Prime Hub', statusColor: 'bg-blue-500', region: 'Southern India' }
  ];

  const coverageStats = [
    { id: 1, icon: 'MapPin', label: 'Regional Hubs', value: '3 Cities' },
    { id: 2, icon: 'Map', label: 'Service Centers', value: '50+ Cities' },
    { id: 3, icon: 'Building2', label: 'Total Coverage', value: 'All Major Cities' }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Global Reach, Local Expertise
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            Serving international clients from UK, US, Canada, UAE with comprehensive PAN India coverage and 24/7 global support
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12">
          {/* Service Delivery Network */}
          <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center">
                <Icon name="Network" size={24} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-foreground">Service Delivery Network</h3>
            </div>
            
            <div className="space-y-3 mb-6">
              {coverageStats?.map((stat) => (
                <div key={stat?.id} className="flex items-center justify-between p-3 bg-muted rounded-lg">
                  <div className="flex items-center gap-3">
                    <Icon name={stat?.icon} size={20} className="text-primary" />
                    <span className="text-base font-medium text-foreground">{stat?.label}</span>
                  </div>
                  <span className="text-base font-bold text-primary">{stat?.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Service Delivery Hubs */}
          <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-lg bg-secondary flex items-center justify-center">
                <Icon name="MapPin" size={24} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-foreground">Service Delivery Hubs</h3>
            </div>
            
            <div className="space-y-3">
              {deliveryHubs?.map((hub) => (
                <div key={hub?.id} className="flex items-center justify-between p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className={`w-3 h-3 rounded-full ${hub?.statusColor}`}></div>
                    <div>
                      <div className="text-base font-bold text-foreground">{hub?.city}</div>
                      <div className="text-sm text-muted-foreground">{hub?.region}</div>
                    </div>
                  </div>
                  <span className="text-xs font-semibold px-3 py-1 rounded-full bg-card border border-border">
                    {hub?.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Response Time & Support */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-8 text-white text-center">
            <Icon name="Clock" size={48} className="mx-auto mb-4" />
            <div className="text-5xl font-bold mb-2">4 Hours</div>
            <div className="text-lg opacity-90">Average Response Time</div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-8 text-white text-center">
            <Icon name="Headphones" size={48} className="mx-auto mb-4" />
            <div className="text-5xl font-bold mb-2">24×7</div>
            <div className="text-lg opacity-90">Support Online</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PANIndiaCoverage;